import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const accessRoute = {
    SAVE_ACCOUNT: "dashboard/core/access/save",
    LIST_COMPANY: "dashboard/core/access/list-by-company",
    LIST_BY_CODE: "dashboard/core/access/list-by-access-code",
};

export default {
    save(access) {
        return new Promise(resolve => {
            const method = access.code ? 'put' : 'post';
            let code = -1;
            http[method](accessRoute.SAVE_ACCOUNT, access)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se guardó el usuario correctamente");
                        return;
                    }
                    toast.error("Error al guardar el usuario");
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    },

    listByCompany(objAccess) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_COMPANY, {
                params: objAccess
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

    findByAccessCode(code) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_BY_CODE,
                {params: {code}})
                .then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
};